//Can be deleted on deploy

export default function FaqError() {
  return (
    <div>
          <h2>Ooops! There's nothing to see here</h2>

          <p>
            Thanks for finding this error!
          </p>

         
    </div>
  );
}
